import React, { useState } from 'react';
import moment from 'moment';

import YesNoModal from 'components/Modals/yesNoModal';
import { userRoles } from 'constants/users';
import { getConfig } from 'functions/getConfig';
import { colors } from 'global/colors';
import { CardContainer, CardTitle } from 'components/CardContainer/CardContainer';
import { SmallButton, SmallButtonLink } from 'components/Button/SmallButton';
import { CardDetails, DetailsLabel } from 'components/CardContainer/styles';
import { ButtonContainer } from './styles';

export default function ContestCard({ userRole, image, contest, link, deleteContest }) {
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [modalInfo, setModalInfo] = useState({});

  return (
    <>
      {showConfirmationModal && (
        <YesNoModal
          modalInfo={modalInfo}
          confirm={(isConfirmed) => {
            if (isConfirmed) deleteContest();
            setModalInfo({});
            setShowConfirmationModal(false);
          }}
        />
      )}
      <CardContainer link={link} image={image}>
        <CardTitle
          name={contest.name}
          tags={[contest.isActive ? 'Active' : 'Inactive']}
          tagColor={contest.isActive ? colors.green2 : colors.red}
        />
        <CardDetails>
          <DetailsLabel>Start date:&nbsp;</DetailsLabel>
          {moment(contest.startDate).format('ll')}
        </CardDetails>
        <CardDetails>
          <DetailsLabel>End date:&nbsp;</DetailsLabel>
          {moment(contest.endDate).format('ll')}
        </CardDetails>
        <CardDetails>
          <DetailsLabel>Total submissions:&nbsp;</DetailsLabel>
          {contest.totalSubmissions ?? 0}
        </CardDetails>
        <CardDetails>
          <DetailsLabel>Total Participants:&nbsp;</DetailsLabel>
          {contest.noOfParticipants ?? 0}
        </CardDetails>
        <CardDetails>
          <DetailsLabel>Total Run:&nbsp;</DetailsLabel>
          {contest.runCount ?? 0}
        </CardDetails>
        <ButtonContainer>
          <SmallButtonLink
            link={`${getConfig().REACT_URL}/cms/contest/${contest._id}`}
            iconName="fa-regular fa-pen-to-square"
            label="Edit"
          />
          <SmallButtonLink
            link={`${getConfig().REACT_URL}/challenges/${contest._id}`}
            iconName="fa fa-external-link"
            label="Visit"
          />
          <SmallButtonLink
            link={`${getConfig().REACT_URL}/cms/result/${contest._id}`}
            iconName="fa fa-list-alt"
            label="Result"
          />
          {userRole === userRoles.SUPER_ADMIN && (
            <SmallButton
              isRedButton
              label="Delete"
              iconName="fa-solid fa-trash"
              onClick={() => {
                setShowConfirmationModal(true);
                setModalInfo({
                  title: 'Confirmation',
                  body: `Do you want to delete ${contest.name}?`,
                });
              }}
            />
          )}
        </ButtonContainer>
      </CardContainer>
    </>
  );
}
